import React, { ReactNode } from 'react';

interface WrapperProps {
  className?: string;
  children: ReactNode;
}

const Wrapper = ({ className, children }: WrapperProps): JSX.Element => (
  <aside
    className={`top-sticky-banner flex min-h-56 w-full flex-row flex-wrap items-center justify-center px-16 py-8 print:!hidden ${className}`}
  >
    {children}
  </aside>
);

export default Wrapper;
